export default __webpack_public_path__ + "42f995f89fa015cd7af6fc39cada57ab.svg";